<template>
  <div id="content">
    <sweet-modal ref="modal" title="Preview">
      <div></div>
    </sweet-modal>
    <div class="contenair">
      <form>
        <h1>&Eacute;léments du formulaire</h1>
        <div class="add-op">
          <button class="btn-blue-inline btn-resize" v-on:click="addNewStep">
            <i class="fa fa-plus"></i> Ajouter une étape
          </button>
        </div>
        <br />
        <BulmaAccordion
          :dropdown="false"
          :icon="'custom'"
          :caretAnimation="{
            duration: '.3s',
            timerFunc: 'ease-in-out',
          }"
          :slide="{
            duration: '.5s',
            timerFunc: 'ease',
          }"
        >
          <div>
            <BulmaAccordionItem>
              <i slot="icon-closed" class="material-icons">
                <svg
                  data-v-bc7d9a68=""
                  version="1.1"
                  viewBox="0 0 129 129"
                  enable-background="new 0 0 129 129"
                  class="header-icon"
                  style="transition: all 0.3s ease-in-out 0s;"
                >
                  <g data-v-bc7d9a68="">
                    <path
                      data-v-bc7d9a68=""
                      d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                    ></path>
                  </g>
                </svg>
              </i>
              <i slot="icon-open" class="material-icons">
                <svg
                  data-v-bc7d9a68=""
                  version="1.1"
                  viewBox="0 0 129 129"
                  enable-background="new 0 0 129 129"
                  class="header-icon caret-down"
                  style="transition: all 0.3s ease-in-out 0s;"
                >
                  <g data-v-bc7d9a68="">
                    <path
                      data-v-bc7d9a68=""
                      d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                    ></path>
                  </g>
                </svg>
              </i>

              <h4 slot="title">Boutons</h4>
              <div class="step-content" slot="content">
                <div class="contenair">
                  <div class="form-elements">
                    <div class="step-contenair">
                      <div class="elem">
                        <label
                          >BOUTON :
                          <span class="defaut"
                            >PR&Eacute;C&Eacute;DENT</span
                          ></label
                        >
                        <input
                          type="text"
                          name="bouton_text[precedent]"
                          v-model="bouton_text.precedent"
                          placeholder="Par défaut : Précedent"
                        />
                      </div>

                      <div class="elem">
                        <label
                          >BOUTON : <span class="defaut">SUIVANT</span></label
                        >
                        <input
                          type="text"
                          name="bouton_text[suivant]"
                          v-model="bouton_text.suivant"
                          placeholder="Par défaut : Suivant"
                        />
                      </div>

                      <div class="elem">
                        <label
                          >BOUTON : <span class="defaut">VALIDER</span></label
                        >
                        <input
                          type="text"
                          name="bouton_text[valider]"
                          v-model="bouton_text.valider"
                          placeholder="Par défaut : Valider"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </BulmaAccordionItem>
          </div>

          <div
            v-for="(step, index) in form"
            :v-bind="form"
            :key="index"
            class="item"
          >
            <BulmaAccordionItem>
              <i slot="icon-closed" class="material-icons">
                <svg
                  data-v-bc7d9a68=""
                  version="1.1"
                  viewBox="0 0 129 129"
                  enable-background="new 0 0 129 129"
                  class="header-icon"
                  style="transition: all 0.3s ease-in-out 0s;"
                >
                  <g data-v-bc7d9a68="">
                    <path
                      data-v-bc7d9a68=""
                      d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                    ></path>
                  </g>
                </svg>
              </i>
              <i slot="icon-open" class="material-icons">
                <svg
                  data-v-bc7d9a68=""
                  version="1.1"
                  viewBox="0 0 129 129"
                  enable-background="new 0 0 129 129"
                  class="header-icon caret-down"
                  style="transition: all 0.3s ease-in-out 0s;"
                >
                  <g data-v-bc7d9a68="">
                    <path
                      data-v-bc7d9a68=""
                      d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                    ></path>
                  </g>
                </svg>
              </i>

              <h4 slot="title" v-if="step.name">{{ step.name }}</h4>
              <h4 slot="title" v-else>&Eacute;tape {{ index + 1 }}</h4>

              <div class="step-content" slot="content">
                <div class="contenair">
                  <label>Nom de l'étape: </label>
                  <input
                    type="text"
                    v-model="step.name"
                    name="form[][name]"
                    placeholder="Name"
                  />
                  <hr />
                  <div class="formelements">
                    <!-- Menu Deroulant (liste des champs ) -->
                    <dropdown :close-on-click="true">
                      <template slot="btn"
                        ><i class="fa fa-plus"></i> &nbsp;Ajouter un élément au
                        formulaire&nbsp;</template
                      >
                      <template slot="body">
                        <div
                          v-for="(element, iElem) in filteredItems"
                          :key="iElem"
                          @click="addField(element, index)"
                          class="fields"
                        >
                          {{ element.name }}
                        </div>
                      </template>
                    </dropdown>
                  </div>
                  <br />

                  <BulmaAccordion
                    :dropdown="false"
                    :icon="'custom'"
                    :caretAnimation="{
                      duration: '.3s',
                      timerFunc: 'ease-in-out',
                    }"
                    :slide="{
                      duration: '.5s',
                      timerFunc: 'ease',
                    }"
                  >
                    <template v-for="(field, i) in form[index].fields">
                      <BulmaAccordionItem :key="i">
                        <i slot="icon-closed" class="material-icons">
                          <svg
                            data-v-bc7d9a68=""
                            version="1.1"
                            viewBox="0 0 129 129"
                            enable-background="new 0 0 129 129"
                            class="header-icon"
                            style="transition: all 0.3s ease-in-out 0s;"
                          >
                            <g data-v-bc7d9a68="">
                              <path
                                data-v-bc7d9a68=""
                                d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                              ></path>
                            </g>
                          </svg>
                        </i>
                        <i slot="icon-open" class="material-icons">
                          <svg
                            data-v-bc7d9a68=""
                            version="1.1"
                            viewBox="0 0 129 129"
                            enable-background="new 0 0 129 129"
                            class="header-icon caret-down"
                            style="transition: all 0.3s ease-in-out 0s;"
                          >
                            <g data-v-bc7d9a68="">
                              <path
                                data-v-bc7d9a68=""
                                d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                              ></path>
                            </g>
                          </svg>
                        </i>
                        <h4 slot="title">
                          Élément {{ i + 1 }} :
                          {{ inputTypeName(field.input_type) }} ({{
                            field.input_type
                          }}) --> <span>{{form[index].fields[i].save_to}}</span>
                        </h4>
                        <div class="step-content" slot="content">
                          <div
                            class="buttons"
                            style="display: flex;justify-content: flex-end;"
                          >
                            <button
                              type="button"
                              class="smallbutton"
                              v-if="!JSONEditorActivated[i]"
                              @click="toggleJSONEditor(i)"
                            >
                              JSON
                            </button>
                            <button
                              type="button"
                              class="smallbutton"
                              v-else
                              @click="toggleJSONEditor(i)"
                            >
                              FORM
                            </button>
                          </div>
                          <div class="container" v-if="!JSONEditorActivated[i]">
                            <component
                              :is="Element"
                              :index="i"
                              :field="form[index].fields[i]"
                            ></component>
                            <br />
                            <a
                              class="remove-field"
                              v-on:click="removeField(index, i)"
                              ><i class="fa fa-trash-o"></i> Supprimer ce
                              champ</a
                            >
                          </div>
                          <div class="container" v-else>
                            <JSONEditor
                              v-model="form[index].fields[i]"
                            ></JSONEditor>
                          </div>
                        </div>
                      </BulmaAccordionItem>
                    </template>
                  </BulmaAccordion>

                  <br />
                  <a class="deletestep" v-on:click="removeStep(index)"
                    ><i class="fa fa-trash-o"></i> Supprimer cette étape</a
                  >
                </div>
              </div>
            </BulmaAccordionItem>
          </div>
        </BulmaAccordion>
        <br />
        <a style="cursor:pointer" v-on:click="goBack()" class="link-back"
          >&lt; Retour au détail</a
        >
        <div class="form-end">
          <button class="btn-blue-inline btn-resize" v-on:click="openModal()">
            <i class="fa fa-eye" aria-hidden="true"></i> Prévisualiser
          </button>
          &nbsp;
          <button class="btn-blue btn-resize" v-on:click.prevent="sumbitForm">
            <i class="fa fa-save"></i> Sauvegarder
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
const Components = require("oxo-form-components");
import Element from "../components/formElements/Element";
import JSONEditor from "../components/JSONEditor";
import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
import Dropdown from "bp-vuejs-dropdown";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import draggable from "vuedraggable";

const components = Components.load("fr-fr");

export default {
  components: {
    Element,
    BulmaAccordion,
    BulmaAccordionItem,
    Dropdown,
    SweetModal,
    SweetModalTab,
    JSONEditor,
    draggable,
  },
  data() {
    return {
      form: [],
      bouton_text: {},
      Filtered: [],
      JSONEditorActivated: {},
      Element: "Element",
      rawElements: components,
      saveToAvailable: [],
      saveToAvailableInitially: []
    };
  },
  computed: {
    elements() {
      return Object.entries(components)
        .map(([k, v]) => {
          v.input_type = k;
          return v;
        })
        .map((e) => {
          if (e.name === undefined) {
            e.name = e.form.label;
          }
          return e;
        });
    },
    filteredItems() {
      return this.elements.filter((item) => {
        let check = JSON.stringify(this.form);
        if (check.indexOf(item.input_type) === -1) {
          return item;
        }
      });
    },
  },
  mounted() {
    this.$axios
      .get("/api/formulaire/" + this.$route.params._id)
      .then((response) => {
        if (response.data.bouton_text) {
          this.bouton_text = response.data.bouton_text;
        } else {
          this.bouton_text = {};
        }

        if (response.data.form) {
          this.form = response.data.form;
        } else {
          this.form = [{}];
        }
      })
      .catch((error) => {
        this.form = [];
      });
  //  this.$axios
  //    .get("/api/formulaire/save_to_values")
  //    .then((response) => {
  //      this.saveToAvailableInitially = response.data;
  //      this.saveToAvailable = response.data;
   //   })
  },
  methods: {
    toggleJSONEditor(index) {
      Vue.set(
        this.JSONEditorActivated,
        index,
        !this.JSONEditorActivated[index]
      );
    },
    inputTypeName(input_type) {
      return this.rawElements[input_type].name !== undefined
        ? this.rawElements[input_type].name
        : this.rawElements[input_type].form.label;
    },
    async sumbitForm() {
      event.preventDefault();
      this.cleanArray();
      this.form.form = this.form;

      console.log(this.bouton_text);

      try {
        let result = await this.$axios.put("/api/formulaire/update/" + this.$route.params._id,
          {
            ...this.form,
            ...{ bouton_text: this.bouton_text },
          }
        );
        if (result.data) {
          this.$swal({
            position: "top-end",
            type: "success",
            title: "Modifications sauvegardées",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    addNewStep: function() {
      event.preventDefault();
      this.form.push(Vue.util.extend({}, this.step));
    },
    removeStep: function(index) {
      this.$swal({
        title: "&Ecirc;tes vous sur ?",
        text: "Supprimer cette étape !",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, je la supprime !",
      }).then((result) => {
        if (result.value) {
          Vue.delete(this.form, index);
          this.$swal(
            "Supprimée !",
            "Cette étape à bien été supprimée.",
            "success"
          );
        }
      });
    },
    addField(child, iStep) {
      if (!this.form[iStep].fields) Vue.set(this.form[iStep], "fields", []);
      this.form[iStep].fields.push({
        input_type: child.input_type,
      });
    },
    removeField: function(iStep, iField) {
      this.$swal({
        title: "&Ecirc;tes vous sur ?",
        text: "Supprimer ce champ !",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, je le supprime !",
      }).then((result) => {
        if (result.value) {
          Vue.delete(this.form[iStep].fields, iField);
          this.$forceUpdate();
          this.$swal(
            "Supprimée !",
            "Le champ et toute ces données à bien été supprimée.",
            "success"
          );
        }
      });
    },
    openModal() {
      event.preventDefault();
      this.$refs.modal.open();
      return;
    },
    cleanArray() {
      this.form.forEach(function(element) {
        if (element === "") {
        }
        console.log(element);
      });
    },
    goBack() {
      this.$router.push("/operation/" + this.$route.params._id);
    },
  },
};
</script>
